module.exports = __webpack_public_path__ + "static/media/close-white.34afc705.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/close-white.svg
// module id = 1549
// module chunks = 0